

import { Filter } from '~src/commonInfra/utils/Filter';
import { RestApiListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/RestApiListResourceFetcher';
import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { IError } from '~src/httpClient/serverApi/types/IError';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { FilterFieldNames, IStringArrayValuedFieldFilterClause } from '~src/spacesPlatform/models/IFilterClause';

import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { IGroupInfo } from '../groups/models/IGroupInfo';
import { GetGroupsRequest } from '../groups/serverApi/requests/GetGroupsRequest';
import { IGroup } from '../groups/serverApi/types/IGroup';
import { IGroupSetBasicInfo, IGroupSetGroupInfo, IGroupSetInfo } from './models/IGroupSetInfo';
import { GroupSetsServerApiHelper } from './serverApi/GroupSetsServerApiHelper';
import { addGroupToGroupSet,IAddGroupToGroupSetResult } from './serverApi/requests/AddGroupToGroupSetRequest';
import { deleteGroupSet } from './serverApi/requests/DeleteGroupSetsRequest';
import { getAllGroupSets } from './serverApi/requests/GetAllGroupSetsRequest';
import { removeGroupFromGroupSet } from './serverApi/requests/RemoveGroupFromGroupSetRequest';
import { updateGroupSet } from './serverApi/requests/UpdateGroupSetRequest';


class GroupSetsResouce {

    private getGroupSetsWorking = new RestApiListResourceFetcher(getAllGroupSets,
        (result) => GroupSetsServerApiHelper.mapGroupSetsFromResult(result)
    );

    all(): ResourceQuery<IGroupSetInfo> {
        return new ResourceQuery<IGroupSetInfo>(this.getGroupSetsWorking);
    }

    getGroupSetGroups(groupSet: IGroupSetBasicInfo): ResourceQuery<IGroupSetGroupInfo> {
        const fetcher = new WebClientListResourceFetcher(GetGroupsRequest, (result) => {
            return result.groups.map((group: IGroup) => {
                 const groupInfo: IGroupSetGroupInfo = {
                   ...group,
                   groupSetId: groupSet.id,
                   contentType: 'group'
                 };
                 return groupInfo;
               }
             );
        });
        return new ResourceQuery(fetcher);
    }

    getGroupSetGroupsFilter(groupSet: IGroupSetBasicInfo): IStringArrayValuedFieldFilterClause {
        let groupNames = groupSet.group?.map((group: IGroupInfo) => {
            return group.name;
        });
        if (groupNames === undefined) {
            groupNames = [];
        }
        const filter = Filter.stringFieldInArray(FilterFieldNames.name, groupNames);
        return filter;
    }

    updateGroupSet(groupSet: IGroupSetInfo, name: string): Promise<IResult> {
        return updateGroupSet(groupSet, name);
    }

    deleteGroupSets(groupSetIds: string[]) {
        groupSetIds.map(groupSetId => {
            deleteGroupSet(groupSetId);
        });
    }

    removeGroupsFromGroupSet(groups: IGroupSetGroupInfo[]) {
        groups.map(group => {
            removeGroupFromGroupSet(group);
        });
    }

    async addGroupsToGroupSet(groups: Set<IGroup>, groupSetId: string): Promise<IAddGroupToGroupSetResult> {
        let resultErrors: IError[] = [];
        let addedGroups: IGroup[] = [];

        for (const selectedGroup of Array.from(groups)) {
            const result = await addGroupToGroupSet(groupSetId, selectedGroup.groupLuid);
            if (result.errors) {
                resultErrors.concat(result.errors);
            } else {
                addedGroups.push(selectedGroup);
            }
        }
        const result: IAddGroupToGroupSetResult = {
            errors: resultErrors,
            groups: addedGroups
        };
        return Promise.resolve(result);
    }
}

export const GroupSets = new GroupSetsResouce();
